import type { AreaDict } from '../messages'

// Detecção de duplicados no import de fatura (só AVISA; a pessoa decide).
const importdup: AreaDict = {
  'pt-BR': {
    'dlg.imp.duplicate': 'já lançado',
    'dlg.imp.dupWarnOne': '{n} linha parece já existir neste cartão — revise antes de importar.',
    'dlg.imp.dupWarnMany': '{n} linhas parecem já existir neste cartão — revise antes de importar.',
    'dlg.imp.dropHint': 'ou arraste o arquivo aqui',
    'dlg.imp.dropNow': 'Solte o arquivo para enviar',
    'dlg.imp.dropReject': 'Formato não aceito. Envie uma imagem ou PDF.',
  },
  en: {
    'dlg.imp.duplicate': 'already added',
    'dlg.imp.dupWarnOne': '{n} row may already exist on this card — review before importing.',
    'dlg.imp.dupWarnMany': '{n} rows may already exist on this card — review before importing.',
    'dlg.imp.dropHint': 'or drag the file here',
    'dlg.imp.dropNow': 'Drop the file to upload',
    'dlg.imp.dropReject': 'Unsupported format. Upload an image or PDF.',
  },
  es: {
    'dlg.imp.duplicate': 'ya registrado',
    'dlg.imp.dupWarnOne': '{n} fila puede que ya exista en esta tarjeta — revisa antes de importar.',
    'dlg.imp.dupWarnMany': '{n} filas puede que ya existan en esta tarjeta — revisa antes de importar.',
    'dlg.imp.dropHint': 'o arrastra el archivo aquí',
    'dlg.imp.dropNow': 'Suelta el archivo para subirlo',
    'dlg.imp.dropReject': 'Formato no admitido. Sube una imagen o PDF.',
  },
}

export default importdup
